import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DelegationsState } from 'src/app/delegations/store/delegations.state';

export const delegationsFeatureKey = 'delegations';
export const delegationsFeature = createFeatureSelector<DelegationsState>(delegationsFeatureKey);

export const selectLoadingAssignedToMeDelegations = createSelector(
    delegationsFeature,
    (state) => state.loadingAssignedToMeDelegations
);
export const selectAssignedToMeDelegations = createSelector(
    delegationsFeature,
    (state) => state.assignedToMeDelegations
);
export const selectAssignedToMeDelegationsSortedByName = createSelector(delegationsFeature, (state) =>
    [...state.assignedToMeDelegations].sort((a, b) =>
        a.delegatingUser.name > b.delegatingUser.name ? 1 : b.delegatingUser.name > a.delegatingUser.name ? -1 : 0
    )
);
export const selectDelegationEmployees = createSelector(delegationsFeature, (state) => state.delegationEmployees);

export const selectLoadingOwnerDelegations = createSelector(
    delegationsFeature,
    (state) => state.loadingOwnerDelegations
);
export const selectOwnerDelegations = createSelector(delegationsFeature, (state) => state.ownerDelegations);

export const selectDelegationTypes = createSelector(delegationsFeature, (state) => state.delegationTypes);
